import React from 'react'
import { Vertical, GridControlBar } from '@gravitate-js/excalibrr'
import { useDirectiveContext } from './DirectiveContext'

import { DefaultDirectiveFilters } from './DefaultDirectiveFilters'

export const DirectivesPage = ({ children, SwitchComponent }) => {
  const { rowCount } = useDirectiveContext()
  return (
    <Vertical className='directives-page' flex={1}>
      <GridControlBar
        title='All Directives'
        rowCount={rowCount}
        actionButtons={<DefaultDirectiveFilters SwitchComponent={SwitchComponent} />}
      />
      {children}
    </Vertical>
  )
}
